//LTDHunt deals module — boundaries: only the public webextension-polyfill
//is imported here; nothing from the bookmarks engine internals.
export const LTDHUNT_API = 'https://app.ltdhunt.com'

//real contract mapped from app/api/deals/submit/* in the LTDHunt
//(ltdhunt-next-reui) codebase — AI extraction happens server-side
//(Inngest + Perplexity), the client only needs the URL.
export const endpoints = {
    session: '/api/auth/session', //NextAuth probe — {} when signed out
    checkDuplicate: '/api/deals/submit/check-duplicate', //public: {url}
    submit: '/api/deals/submit', //session: {url} → AI pipeline
    drafts: '/api/deals/submit/draft', //session: draft CRUD
    finalize: '/api/deals/submit/finalize', //session: persist + moderate
    deal: '/api/deals/', //public GET {id} → deal with slug + tool.slug
    chatTimeline: '/api/chat/timeline', //public GET ?tool_slug=&limit=&offset=
    chatSend: '/api/chat/send', //session: {toolSlug, content, replyToId?}
    search: '/api/search', //public GET ?query=&limit= → {tools[], deals[]}
    similarDeals: '/api/tools/', //public GET {toolId}/similar-deals?limit=
    reminders: '/api/reminders', //session: {entity_type, entity_id?, title, note?, remind_at, original_payload?}
}
